import { render, staticRenderFns } from "./Garantia.vue?vue&type=template&id=bc695d1e&scoped=true"
import script from "./Garantia.vue?vue&type=script&lang=js"
export * from "./Garantia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc695d1e",
  null
  
)

export default component.exports